<template>
  <span class="common-input" :class="{'common-input-no-label': !label, 'input-inline': inline, 'common-input-primary': primary}">
    <span class="label" v-if="label">{{ label }}</span>
    <!-- <input class="hidden" :name="name" v-if="type === 'text'"> -->
    <!-- <input class="hidden" :name="name" v-else autocomplete="new-password" :id="name"> -->
    <input
      :type="type"
      ref="input"
      v-bind="$props"
      :maxlength="maxlength"
      @input="handleInput"
      @blur="handleBlur"
      @keyup="handleKeyUp"
      :placeholder="placeholder"
      :value="currentValue"
      :class="{'common-input-error': error}"
      autocomplete="new-password"
      @focus="handleOnFocus"
      :readonly="isReadonly"
    >
    <span
      v-if="notSupportPlaceholder && showPlaceholder"
      class="placeholder"
      :class="{'placeholder-no-label': !label}"
      @click="handlePlaceholderClick"
    >{{ placeholder }}</span>
    <span class="error-tip" v-show="error">{{ error }}</span>
  </span>
</template>
<script>
export default {
  name: 'c-input',
  props: {
    // focus: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    inline: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false,
      required: false
    },
    number: {
      default: false,
      type: Boolean,
    },
    /**
     * 支持的小数位，仅设置了number选项时生效
     */
    maxFloat: {
      default: 0,
      type: Number,
    },
    name: String,
    label: String,
    suffix: String,
    maxlength: [String, Number],
    // onChange: Function,
    value: [String, Number],
    placeholder: String,
    onBlur: Function,
    // rule: Object, // 规则对象{message: '要提示的文字', pattern: 正则}
    error: String // 传递一个错误，内容为要提示的内容
    // requiredText: String, // 传递该字段表示必填，内容为要提示的文字,
    // validator: Object
  },
  data() {
    return {
      currentValue: this.value,
      notSupportPlaceholder: false,
      showPlaceholder: false,
      initValueDone: false,
      isReadonly: true,
    }
  },
  methods: {
    setCurrentValue(v) {
      this.currentValue = v
    },
    handlePlaceholderClick() {
      this.$refs.input.focus()
    },
    handleKeyUp(e) {
      if (this.notSupportPlaceholder && this.$refs.input.value) {
        this.showPlaceholder = false
      } else if (this.notSupportPlaceholder && !this.$refs.input.value) {
        this.showPlaceholder = true
      }
      this.setCurrentValue(this.$refs.input.value)
      this.$emit('keyup', e)
    },
    handleInput(e) {
      if (!this.initValueDone) {
        return
      }
      let v = e.target.value
      this.$emit('input', v)
      this.onChange && this.onChange(this.name, v)
      this.setCurrentValue(v)
      this.$emit('input', v)
      if (this.number) {
        this.transformValue(v);
      }
    },
    handleBlur() {
      let value = this.currentValue;
      if (this.number) {
        value = this.toFixNumber(this.currentValue);
        this.updateValue(value);
      }
      this.$emit('blur', value);
      this.onBlur && this.onBlur(value);
    },
    transformValue(value) {
      if (value === '.' || value === '') {
        return this.updateValue('');
      }
      if (this.maxFloat) {
        return this.updateValue(this.toNumber(value));
      }
      return this.updateValue(value.replace(/\D/g, '').substr(0, this.maxLength));
    },
    updateValue(value) {
      this.setCurrentValue(value);
      this.$emit('input', value);
    },
    toFixNumber(value = '') {

      if (value === '') {
        return '';
      }
      // const start = value.indexOf()

      if (this.maxFloat) {
        return '' + Number(event.target.value).toFixed(this.maxFloat);
      }

      return event.target.value;
    },
    toNumber(value) {
      value = String(value).replace(/([^\d.])/g, '').replace(/\.+/g, '.');

      const index = value.indexOf('.');
      const lastIndex = value.lastIndexOf('.');
      const maxLength = +this.maxLength;

      if (value === '') {
        return '';
      }
      if (index === -1) {
        // 如果要对位数进行限制，且没有.(纯整数)的情况下，就截取到maxLength
        value = maxLength ? value.substr(0, maxLength) : value;
        return value;
      }

      // 当.是最后一位时，就
      if (index === value.length - 1) {
        value = value.substring(0, index + this.maxFloat + 1);
      } else {
        if (index === lastIndex) {
          value = value.substring(0, index + this.maxFloat + 1);
        } else {
          value = value.substring(0, lastIndex);
        }
      }
      return value;
    },
    startTimer() {
      this.$timer = setTimeout(() => {
        this.isReadonly = false;
      }, 500);
    },
    handleOnFocus() {
      if (this.isReadonly) {
        this.isReadonly = false;
      }
    },
  },
  beforeDestroy() {
    // clearTimeout(this.$timer);
  },
  mounted() {
    if (!('placeholder' in this.$refs.input)) {
      this.showPlaceholder = true
      this.notSupportPlaceholder = true
    }
    if (this.focus) {
      this.$refs.input.focus()
    }
    this.$nextTick(() => {
      this.initValueDone = true
    });
    // this.startTimer();
  },
  watch: {
    value(val, oldValue) {
      this.setCurrentValue(val)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
